import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { User, apiFetch } from '@/core';
import env from '@/env';

type AuthResponseDto = {
  accessToken: string;
  user: User;
};

type FinishRegistrationBody = {
  password: string;
  confirmPassword: string;
  defaultConnectionId: string;
  registrationUrlId: string;
};

export const finishRegistration = async ({
  data,
}: {
  data: FinishRegistrationBody;
}): Promise<AuthResponseDto> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auth/finish-registration`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...data,
        companyId: env.VITE_IDSYSDBCOMPANY,
      }),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuthResponseDto;
  return response;
};
